<template>
  <div class="modalUser">
    <b-modal id="modalUserSettings" @show="onOpen" ref="modalUserSettings" modal-class="modalsmall top-mb" centered no-close-on-backdrop>
      <template v-slot:modal-header>
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100">
          <h2 class="title text-uppercase">ユーザーアップロード設定</h2>
          <p class="sub-title">   </p>
        </div>
      </template>
      <div class="modalUser--main">
        <b-row>
            <b-col cols="12">
              <b-form-group label="ビデオのアップロード時間（分）" label-for="max_video_duration">
                <b-form-select v-model="settings.max_video_duration" class="input-form" :options="durationOptions"></b-form-select>
              </b-form-group>
            </b-col>
        </b-row>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 button-group">
          <b-button
            variant="primary"
            :disabled="buttonLoad"
            class="btn btn-rounder btn-login w-100"
            type="button" @click="saveSettings($route.params.employee_id)">
              設定を保存する
              <span v-if="buttonLoad">
                <b-spinner small></b-spinner>
              </span>
          </b-button>
        </div>
        <b-button
          :disabled="buttonLoad"
          class="btn btn-rounder btn-second btn-cancel w-100"
          type="button" @click="$bvModal.hide(`modalUserSettings`)">キャンセル</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
export default {
  name: 'FileSettings',
  components: {
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  props: {
    user: {
      Type: Object,
      Defaults: {}
    }
  },
  data () {
    return {
      buttonLoad: false,
      durationOptions: [
        {value: 5, text: '5分'},
        {value: 10, text: '10分'},
        {value: 30, text: '30分'}
      ],
      settings: {
        max_video_duration: 5
      }
    }
  },
  methods: {
    onOpen () {
      this.settings = this.user.settings
    },
    async saveSettings (employeeID) {
      this.buttonLoad = true
      this.settings.userID = employeeID
      await this.$store.dispatch('adminEmployee/setSettings', this.settings)
      setTimeout(() => {
        this.buttonLoad = false
        this.$bvModal.hide(`modalUserSettings`)
      }, 500)
    }
  },
  watch: {
    user (newVal) {
      this.settings = newVal.settings
    }
  }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/Employee/FileSettings.vue